import { userConstants } from '../constants';

const initialState = { show: false }

export function spinner(state = initialState, action) {
    console.log('actionType',action);
    switch (action.type) {
        case userConstants.SHOW_LOADING_SPINNER:
            return {
                show: action.show
            }
        case userConstants.HIDE_LOADING_SPINNER:
            return {
                show: action.show
            }
        default:
            return state
    }
}